import { ControlInterface } from 'edocatbase/Form';
import NewDatePicker from '../../../DatePicker/DatePicker';
const { moment } = window;

export default class DateRange extends React.PureComponent<ControlInterface> {
	onStartChange = (date: any) => {
		const { onChange, name, dirty, value } = this.props;
		const startValue = date ? moment(date).startOf('day') : null;

		onChange(
			[name],
			{
				...value,
				start: startValue,
			},
			dirty
		);
	};

	onEndChange = (date: any) => {
		const { onChange, name, dirty, value } = this.props;
		const endValue = date ? moment(date).endOf('day') : null;

		onChange(
			[name],
			{
				...value,
				end: endValue,
			},
			dirty
		);
	};

	onBlur() {
		const { onBlur, name, value, dirty } = this.props;

		if (onBlur) {
			onBlur(name, value, dirty);
		}
	}

	copyValueToRight = (event: React.MouseEvent) => {
		event.preventDefault();

		const { value } = this.props;
		this.onEndChange(value.start);
	};

	copyValueToLeft = (event: React.MouseEvent) => {
		event.preventDefault();

		const { value } = this.props;
		this.onStartChange(value.end);
	};

	render() {
		const {
			label,
			disabled,
			value,
			control: {
				params: { minDate, dateFormat },
			},
			mandatory,
			name,
			className,
		} = this.props;

		const valueStart = value ? value.start || value.minValue || null : null;
		const valueEnd = value ? value.end || value.maxValue || null : null;
		return (
			<div className={`form-row row-${name}`}>
				<div className="Date-Range-Value">
					<NewDatePicker
						label={label || window.Alfresco.messages.global['edocat.audit-page.filters.fromTime']}
						className={`Date-Range-Input Date-Range-Start ${className}`}
						dateFormat={dateFormat}
						disabled={disabled}
						endDate={value?.end || null}
						isClearable={!mandatory}
						maxDate={value?.end || null}
						minDate={minDate}
						name={`${name} start`}
						onBlur={this.onBlur}
						onChange={this.onStartChange}
						selected={typeof value === 'string' ? value : valueStart}
					/>
					{valueStart && !valueEnd && <i className="copy-date fas fa-arrow-right" onClick={this.copyValueToRight} />}
					{valueEnd && !valueStart && <i className="copy-date fas fa-arrow-left" onClick={this.copyValueToLeft} />}

					{((!valueEnd && !valueStart) || (valueEnd && valueStart)) && <span className="copy-date" />}

					<NewDatePicker
						label={window.Alfresco.messages.global['edocat.audit-page.filters.dueTo']}
						className={`Date-Range-Input Date-Range-End ${className}`}
						dateFormat={dateFormat}
						disabled={disabled}
						isClearable={!mandatory}
						minDate={minDate || valueStart || null}
						name={`${name} end`}
						onBlur={this.onBlur}
						onChange={this.onEndChange}
						selected={typeof value === 'string' ? value : valueEnd}
					/>
				</div>
			</div>
		);
	}
}
